import APIClient from '@/shared/http/clients/api'

const resourceName = 'clienterh'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}`, data, config)
const GetAllPaging = (companyID, limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}?limit=${limit}&index=${index}`, config)
const GetAllByName = (companyID, name, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/nome/${name}`, data, config)
const GetByCode = (companyID, code, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/codigo/${code}`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)

const ClienteRHRepository = {
  GetAll,
  GetAllPaging,
  GetAllByName,
  GetByCode,
  GetById,
  Create,
  Update,
  Delete
}

export default ClienteRHRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/clientrh.js